import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./Navbar.module.scss";
import { CgMenuLeftAlt } from "react-icons/cg";

import SideBar from "./SideBar";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const hanldeClick = () => {
    setToggle(!toggle);
  };

  return (
    <header className={styles.header}>
      <nav className={styles.navbar}>
        <div className={styles.toggle}>
          <button onClick={hanldeClick}>
            <CgMenuLeftAlt onClick={hanldeClick} className={styles.icons} />
          </button>

          {toggle && <SideBar />}
        </div>

        <Link href={'/'}>
          <Image
            src='/assets/Image/Logo.png'
            width={205}
            height={45.25}
            className={styles.image}
            alt='logo'
          />
        </Link>

        <ul className={styles.listitems}>
          <li className={styles.item}>
            <Link href={'/'}>Home</Link>
          </li>
          <li className={styles.item}>
            <Link href={'/tokenRewards'}>Token Rewards</Link>
          </li>
          <li className={styles.item}>
            <Link href={'/bloveToken'}>B-Love Token</Link>
          </li>

          <li className={styles.item}>
            <Link href={'/privacy'}>Privacy Policy</Link>
          </li>

          <li className={styles.item}>
            <Link href={'https://ito.blove.network/'}>ITO</Link>
          </li>
        </ul>

        <Link
          target='_blank'
          href={
            'https://play.google.com/store/apps/details?id=biz.innovationfactory.bnetwork&hl=en_US&pli=1'
          }
          className={styles.downloadBtn}
        >
          DownLoad
        </Link>
      </nav>
    </header>
  )
};

export default Navbar;
